export const SHADE_PICKER_DIALOG = 'shade-picker-dialog';
export const transitionProps = {
  timeout: 0
};
//# sourceMappingURL=constants.js.map